export default __webpack_public_path__ + "c5499260b9378271485563888406efa4.png";